import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import ArchiveIcon from '@mui/icons-material/Archive';
import InventoryIcon from '@mui/icons-material/Inventory';

const ArchiveAlertActions = ({ alert, clickHandler, isArchiving }) => {
  return (
    <Box sx={{ display: 'flex', gap: 0.5 }}>
      <Tooltip title="Archive" arrow placement="right">
        <IconButton
          onClick={() => clickHandler(alert.id, false)}
          size="small"
          disabled={isArchiving}
          sx={{
            '&:hover': {
              backgroundColor: 'action.hover',
              color: 'primary.main',
            },
            transition: 'all 0.2s',
          }}
        >
          <ArchiveIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {alert.shouldAllowArchiveForAllUsers && !alert.archiveForAllUsers && (
        <Tooltip title="Archive for Everyone" arrow>
          <IconButton
            onClick={() => clickHandler(alert.id, true)}
            size="small"
            disabled={isArchiving}
            sx={{
              '&:hover': {
                backgroundColor: 'action.hover',
                color: 'warning.main',
              },
              transition: 'all 0.2s',
            }}
          >
            <InventoryIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default ArchiveAlertActions;
